import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { apiErr } from "@/lib/api";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function Login() {
  const { login } = useApp();
  const navigate = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(form);
      toast.success("Welcome back!");
      const dest = loc.state?.from || (u.role === "admin" ? "/admin" : "/dashboard");
      navigate(dest, { replace: true });
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="text-center mb-8"><Logo /></div>
      <div className="asf-card p-8">
        <h1 className="font-display text-2xl font-bold mb-1">Welcome back</h1>
        <p className="text-sm text-slate-500 mb-6">Log in to continue learning.</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" type="email" required placeholder="Email"
            className="w-full rounded-xl bg-asf-app border border-slate-200 px-4 py-3 outline-none focus:border-asf-orange"
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          <input data-testid="login-password" type="password" required placeholder="Password"
            className="w-full rounded-xl bg-asf-app border border-slate-200 px-4 py-3 outline-none focus:border-asf-orange"
            value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          <button data-testid="login-submit" disabled={loading} className="btn-primary w-full py-3.5">
            {loading ? "Logging in…" : "Log In"}
          </button>
        </form>
        <div className="flex items-center gap-3 my-5">
          <div className="flex-1 h-px bg-slate-200" /><span className="text-xs text-slate-400">or</span><div className="flex-1 h-px bg-slate-200" />
        </div>
        <button data-testid="google-login" onClick={() => { const r = window.location.origin + "/auth/callback"; window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(r)}`; }}
          className="btn-secondary w-full py-3.5 flex items-center justify-center gap-2">
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="h-4 w-4" /> Continue with Google
        </button>
        <p className="text-sm text-slate-500 mt-5 text-center">
          No account? <Link to="/register" className="text-asf-orange font-semibold">Create one</Link>
        </p>
      </div>
    </div>
  );
}
